import config from '@/config'
import { Route } from '@/contracts/core/api/entity/Route'

/** Маршруты модуля note (/api/note): работать ли без сервера, решает настройка модуля в src/config.ts */
export abstract class NoteRoute<P, T> extends Route<P, T> {
  isOffline(): boolean {
    return config.modules.note.isOffline()
  }
}
